var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{key:_vm.$route.fullPath}),_c('keep-alive',{attrs:{"include":"team,report,search"}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }